import $ from "jquery";

export default {
	init() {
		if ($(".our-team-section").length > 0) {
			$(".our-team-section .our-team-grid").slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
						},
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
		}
		// Gallary slider
		if ($(".pm-gallary-section").length > 0) {
			$(".pm-gallary-section .pm-gallary-grid-main").slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				responsive: [
					// {
					//   breakpoint: 991,
					//   settings: {
					//     slidesToShow: 3,
					//     slidesToScroll: 1,
					//   },
					// },
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
						},
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
		}

		$(".grid-icons figure").matchHeight();

		$(".home-recent-posts .post-content").matchHeight();

		$(".wp-block-gallery .wp-block-image a").attr("data-fancybox", "gallery");

		$("article .details").matchHeight();
		$(".our-team-grid-outer .our-team-grid .our-team-inner .content-block h3"
		).matchHeight();
		$(".our-team-grid-outer .our-team-grid .our-team-inner .content-block p"
		).matchHeight();
		$(".pm-course-grid .pm-course-item .pm-course-item-inner p:not(.course-catagory)"
		).matchHeight();
		$(".pm-course-grid .pm-course-item-inner h3").matchHeight();
		$(".related-course-category .related-course-category-grid .grid-item__content p"
		).matchHeight();
		$(".related-course-category .grid-container .grid-item__thumbnail"
		).matchHeight();
		$(".pm-has-common-grid-layout .pm-blog-listing-main .pm-blog-listing-item .pm-blog-listing-inner .content-block h3"
		).matchHeight();
		$(".success-stories-listing .site-main .generate-columns-container .post-content .entry-title"
		).matchHeight();

		$(".category-pitman-blog .generate-columns-container .entry-title a"
		).matchHeight();
		$(".address-wrapper address").matchHeight();
		$(".our-team-section .our-team-grid-outer .our-team-grid .our-team-item .our-team-outer"
		).matchHeight();

		if ($(".tablinks").length > 0) {
			jQuery('.tablinks:first').addClass('active');
		    jQuery('.tabcontent:first').show();

		    jQuery('.tablinks').on('click', function(event) {
		        event.preventDefault();
		        var tabId = jQuery(this).data('tab');
		        // Remove active class from all tabs and hide all tab contents
		        jQuery('.tablinks').removeClass('active');
		        jQuery('.tabcontent').hide();
		        // Add active class to the clicked tab and show its content
		        jQuery(this).addClass('active');
		        jQuery('#' + tabId).show();
		    });
		}

		if ($(window).width() < 1199) {
			$(".menu-toggle").click(function () {
				$("html,body").toggleClass("open-menu");
			});
		} else {
			$(".main-navigation .main-nav>.menu>li").hover(function () {
				$("html,body").toggleClass("open-menu");
			});
			$(
				".main-nav > ul > li > .sub-menu .menu-item-has-children:not(.mega-menu-column)"
			).each(function () {
				$(this).append("<span class='has-dropdown'></span>");
			});
			$(document).on("click", ".has-dropdown", function () {
				console.log("TEst");
				$(this).closest("li").siblings().removeClass("active");
				$(this).closest("li").toggleClass("active");
				$(this).closest("li").siblings().find(".sub-menu").slideUp();
				$(this).closest("li").find(".sub-menu").addClass("slide-down");
				$(this).closest("li").find(".sub-menu").slideToggle();
			});
		}

		$(".home-filters").on("click", "#filters-toggle", function () {
			console.log("clocked");
			let filters = $(this).parents().find(".filters-wrap");
			let filtersAriaLabel =
				"false" == $(this).parents().find(".filters-wrap").attr("aria-expanded")
					? "true"
					: "false";
			filters.toggleClass("open");
			filters.attr("aria-expanded", filtersAriaLabel);
		});

		$(".acf-block-location-links").on("click", "a", function (e) {
			var id = $(this).attr("href");

			// target element
			var $id = $(id);
			if ($id.length === 0) {
				return;
			}

			// prevent standard hash navigation (avoid blinking in IE)
			e.preventDefault();

			// top position relative to the document
			var pos = $id.offset().top - 30;

			$(this).parents().find("li").removeClass("current-menu-item");

			$(this).parent("li").addClass("current-menu-item");

			// animated top scrolling
			$("body, html").animate({ scrollTop: pos });
		});

		$(".hero-select").on("click", "button", function (event) {
			event.preventDefault();
			var location = $("#hero-redirect").val();

			if (null !== location) {
				window.location = location;
			}
		});

		$("#more-toggle").on("click", function () {
			let $toggle = $(this);
			if ($toggle.attr("aria-expanded") === "false") {
				$toggle.find("span").html("[-]");
			} else {
				$toggle.find("span").html("[+]");
			}
		});
		observe_page();
		function observe_page() {
			var whatToObserve = {
				childList: true,
				attributes: true,
				subtree: true,
				attributeOldValue: true,
				attributeFilter: ["class", "style"],
			};
			var mutationObserver = new MutationObserver(function (mutationRecords) {
				$.each(mutationRecords, function (index, mutationRecord) {
					if (mutationRecord.type === "childList") {
						if (mutationRecord.addedNodes.length > 0) {
							//DOM node added, do something
							var load_more = $("#tsLoadMore");
							if (
								$(load_more).length > 0 &&
								$(".load-more-wrapper").length == 0
							) {
								load_more.wrap("<div class='load-more-wrapper'></div>");
							}

							var images = $(".ts-reviewLogo");

							if (images.length > 0) {
								$("link[href*='cleanslate.css']").attr("disabled", "disabled");
								//$("link[href*='reviewlist.css']").attr("disabled", "disabled");

								//images.removeAttr("style");
								$(".ts-reviewLogo img").attr("style", "");
								$(".ts-reviewTitle").attr("style", "");

								$(".ts-reviewText").attr("style", "");

								$(".ts-reviewContent *").attr("style", "");
							}
						} else if (mutationRecord.removedNodes.length > 0) {
							//DOM node removed, do something
						}
					} else if (mutationRecord.type === "attributes") {
						if (mutationRecord.attributeName === "class") {
							//class changed, do something
						}
					}
				});
			});
			mutationObserver.observe(document.body, whatToObserve);

			//
		}
		$(document).on(
			"click",
			".facetwp-facet.facetwp-facet-load_more.facetwp-type-pager",
			function () {
				setTimeout(() => {
					$(this).hide();
				}, 1000);
			}
		);

		// fancy image
		if ($(".pm-gallary-section ").length > 0) {
			$(".pm-gallary-section .pm-gallary-grid-item .pm-gallary-inner").attr(
				"data-fancybox",
				"pitman-photo-gallary"
			);
			$(".pm-gallary-section .pm-gallary-grid-item .pm-gallary-inner").each(
				function () {
					$(this).attr("data-caption", $(this).find("img").attr("alt"));
					$(this).attr("title", $(this).find("img").attr("alt"));
				}
			);
			$(
				".pm-gallary-section .pm-gallary-grid-item .pm-gallary-inner"
			).fancybox();
		}
	},
};
